import axios from 'axios';
import CryptoJS from 'crypto-js';
import integrationEscl from '../locales/es-CL/integration.json';
import integrationEsmx from '../locales/es-MX/integration.json';
import integrationEsco from '../locales/es-CO/integration.json';
import integrationEnus from '../locales/en-US/integration.json';
import showConfirmation from '../confirmation/confirmationHandler';

export default {
  name: 'Integrations',
  components: {},
  i18n: {
    messages: {
      'es-CL': {
        integration: integrationEscl,
      },
      'es-MX': {
        integration: integrationEsmx,
      },
      'es-CO': {
        integration: integrationEsco,
      },
      'en-US': {
        integration: integrationEnus,
      },
    },
  },
  data() {
    return {
      deleteIntegrationBusy: false,
      selectedIntegration: null,
      activeWoocomerce: false,
      integrations: ['API', 'Shopify', 'Woocommerce'],
      lastmileIntegrationLink: '',
      token: '',
      secret: '',
      isSecretValid: true,
      isTokenValid: true,
      isWoocommerceBussy: false,
      lastmileWebhookLink: '',
      lastmileAPILink: '',
      lastmileAPITroncalLink: '',
      lastmileRoutePlannerLink: '',
      isLoading: false,
      dominio: null,
      urlIframe: null,
      urlPreview: null,
      currentTab: 'integration',
      isWidgetCreated: false,
      iframeCode: null,
      isModalOpen: false,
      badUrl: false,
      dataAccess: null,
      tabPosition: 'left',
      showFullImage1: false,
      showFullImage2: false,
      showFullImage3: false,
      showFullImage4: false,
      showFullImage5: false,
      showFullImage6: false,
      showFullImage7: false,
      showFullImage8: false,
      showFullImage9: false,
      showFullImage10: false,
      showFullImage11: false,
      imagesShopify: [
        require('../assets/integration/shopify/Imagen 1.jpg'),
        require('../assets/integration/shopify/Imagen 2.jpg'),
        require('../assets/integration/shopify/Imagen 3.jpg'),
        require('../assets/integration/shopify/Imagen 4.jpg'),
        require('../assets/integration/shopify/Imagen 5.jpg'),
        require('../assets/integration/shopify/Imagen 6.jpg'),
        require('../assets/integration/shopify/Imagen 7.jpg'),
        require('../assets/integration/shopify/Imagen 8.jpg'),
        require('../assets/integration/shopify/Imagen 9.jpg'),
        require('../assets/integration/shopify/Imagen 10.jpg'),
        require('../assets/integration/shopify/Imagen 11.jpg'),
      ],
      imagesWC: [
        require('../assets/integration/woocommerce/1.jpg'),
        require('../assets/integration/woocommerce/2.jpg'),
        require('../assets/integration/woocommerce/3.jpg'),
        require('../assets/integration/woocommerce/4.jpg'),
        require('../assets/integration/woocommerce/5.jpg'),
        require('../assets/integration/woocommerce/6.jpg'),
        require('../assets/integration/woocommerce/7.jpg'),
        require('../assets/integration/woocommerce/8.jpg'),
        require('../assets/integration/woocommerce/9.jpg'),
        require('../assets/integration/woocommerce/10.jpg'),
        require('../assets/integration/woocommerce/11.jpg'),
        require('../assets/integration/woocommerce/12.jpg'),
        require('../assets/integration/woocommerce/13.jpg'),
        require('../assets/integration/woocommerce/14.jpg'),
        // Agrega todas las imágenes aquí
      ],
      mapItemsWC: [
        {
          woocommerceColumn: this.$t('integration.woocommerce.mapTable.idOrder'),
          lastmileColumn: this.$t('integration.woocommerce.mapTable.nameOperation'),
        },
        {
          woocommerceColumn: this.$t('integration.woocommerce.mapTable.addressWC'),
          lastmileColumn: this.$t('integration.woocommerce.mapTable.addressLM'),
        },
        {
          woocommerceColumn: this.$t('integration.woocommerce.mapTable.addressExtraWC'),
          lastmileColumn: this.$t('integration.woocommerce.mapTable.addressExtraLM'),
        },
        {
          woocommerceColumn: this.$t('integration.woocommerce.mapTable.cityWC'),
          lastmileColumn: this.$t('integration.woocommerce.mapTable.cityLM'),
        },
        {
          woocommerceColumn: this.$t('integration.woocommerce.mapTable.stateWC'),
          lastmileColumn: this.$t('integration.woocommerce.mapTable.stateLM'),
        },
        {
          woocommerceColumn: this.$t('integration.woocommerce.mapTable.countryWC'),
          lastmileColumn: this.$t('integration.woocommerce.mapTable.countryLM'),
        },
        {
          woocommerceColumn: this.$t('integration.woocommerce.mapTable.priceWC'),
          lastmileColumn: this.$t('integration.woocommerce.mapTable.priceLM'),
        },
        {
          woocommerceColumn: this.$t('integration.woocommerce.mapTable.receiverWC'),
          lastmileColumn: this.$t('integration.woocommerce.mapTable.receiverLM'),
        },
        {
          woocommerceColumn: this.$t('integration.woocommerce.mapTable.receiverPhoneWC'),
          lastmileColumn: this.$t('integration.woocommerce.mapTable.receiverPhoneLM'),
        },
        {
          woocommerceColumn: '-',
          lastmileColumn: this.$t('integration.woocommerce.mapTable.defaultTimeLM'),
        },
      ],
      mapItems: [
        {
          shopifyColumn: this.$t('integration.shopify.instalationDescription.mapTable.idOrder'),
          lastmileColumn: this.$t('integration.shopify.instalationDescription.mapTable.operationName'),
        },
        {
          shopifyColumn: this.$t('integration.shopify.instalationDescription.mapTable.shippingAddress'),
          lastmileColumn: this.$t('integration.shopify.instalationDescription.mapTable.operationAddress'),
        },
        {
          shopifyColumn: this.$t('integration.shopify.instalationDescription.mapTable.extraShippingAddress'),
          lastmileColumn: this.$t('integration.shopify.instalationDescription.mapTable.extraOperationAddress'),
        },
        {
          shopifyColumn: this.$t('integration.shopify.instalationDescription.mapTable.cityAddress'),
          lastmileColumn: this.$t('integration.shopify.instalationDescription.mapTable.operationCity'),
        },
        {
          shopifyColumn: this.$t('integration.shopify.instalationDescription.mapTable.provinceAddress'),
          lastmileColumn: this.$t('integration.shopify.instalationDescription.mapTable.operationState'),
        },
        {
          shopifyColumn: this.$t('integration.shopify.instalationDescription.mapTable.countryAddress'),
          lastmileColumn: this.$t('integration.shopify.instalationDescription.mapTable.operationCountry'),
        },
        {
          shopifyColumn: this.$t('integration.shopify.instalationDescription.mapTable.latLonAddress'),
          lastmileColumn: this.$t('integration.shopify.instalationDescription.mapTable.operationLatLon'),
        },
        {
          shopifyColumn: this.$t('integration.shopify.instalationDescription.mapTable.totalWeightOrder'),
          lastmileColumn: this.$t('integration.shopify.instalationDescription.mapTable.operationWeight'),
        },
        {
          shopifyColumn: this.$t('integration.shopify.instalationDescription.mapTable.totalMoneyOrder'),
          lastmileColumn: this.$t('integration.shopify.instalationDescription.mapTable.operationMoney'),
        },
        {
          shopifyColumn: this.$t('integration.shopify.instalationDescription.mapTable.receiverName'),
          lastmileColumn: this.$t('integration.shopify.instalationDescription.mapTable.operationReceiverName'),
        },
        {
          shopifyColumn: this.$t('integration.shopify.instalationDescription.mapTable.receiverPhone'),
          lastmileColumn: this.$t('integration.shopify.instalationDescription.mapTable.operationReceiverPhone'),
        },
        {
          shopifyColumn: '-',
          lastmileColumn: this.$t('integration.shopify.instalationDescription.mapTable.operationDefaultTime'),
        },
      ],
      activeImage: null,
    };
  },
  async created() {
    this.dataAccess = this.$store.getters.dataAccess;
    await this.getLastmileToken();
    this.activeWoocomerce = await this.existSecret();
    const parentDomain = window.parent.location.hostname;
    this.urlPreview = this.buildUrl(parentDomain);
    this.lastmileAPILink = this.$store.getters.urlAPI;
    this.lastmileAPITroncalLink = this.$store.getters.urlDocumentationTroncal;
    this.lastmileRoutePlannerLink = this.$store.getters.urlDocumentationRoutePlanner;
  },
  mounted() {
    document.addEventListener('keydown', this.handleEscape);
  },
  beforeDestroy() {
    document.removeEventListener('keydown', this.handleEscape);
  },
  methods: {
    openImage(index) {
      this.activeImage = index;
    },
    /**
     * Este metodo provoca que si presiono escape y hay una imagen seleccionada debe cambiar el estado para cerrarla
     * @param {*} event
     */
    handleEscape(event) {
      if (event.key === 'Escape' && this.activeImage !== null) {
        this.activeImage = null; // Cierra solo la imagen sin afectar el modal
      } else if (event.key === 'Escape' && this.activeImage === null) {
        this.closeModal('guide-steps');
      }
    },
    async getLastmileToken() {
      this.isLoading = true;
      const response = await axios.get(this.$store.getters.urlAPI + '/api/client/token', {
        headers: {
          'id-client': this.$store.getters.clientId,
          Authorization: `Bearer ${this.$store.getters.accessToken}`,
        },
      });
      const token = response.data.data;
      this.token = token;
      console.log(this.$store.getters.urlWebhook, this.$store.getters.urlAPI);
      this.lastmileIntegrationLink = this.$store.getters.urlAPI + '/api/shopify/orderCreated/' + token;
      this.lastmileWebhookLink = `${this.$store.getters.urlWebhook}/orderCreated/${token}`;
      this.isLoading = false;
    },
    goToAnotherPage(url) {
      window.open(url, '_blank');
    },
    copyLastmileAPILink() {
      navigator.clipboard.writeText(this.lastmileAPILink);
    },
    copyLastmileToken() {
      navigator.clipboard.writeText(this.lastmileIntegrationLink);
    },
    copyLastmileIframe() {
      navigator.clipboard.writeText(this.iframeCode);
    },
    copyUrlWebhook() {
      navigator.clipboard.writeText(this.lastmileWebhookLink);
    },
    async changeTab(navBar) {
      this.currentTab = navBar;
    },
    async saveWebhookCOnfig() {
      this.isWoocommerceBussy = true;
      if (this.validateWebhookData()) {
        await this.saveCredentials();
      }
      this.isWoocommerceBussy = false;
    },
    validateWebhookData() {
      const validSecret = this.validSecret();
      const validToken = this.validToken();

      return validSecret && validToken;
    },
    validSecret() {
      if (this.secret) {
        this.isSecretValid = true;
        return true;
      }
      this.isSecretValid = false;
      this.showPopover('fldSecret');
      return false;
    },
    validToken() {
      if (this.token) {
        this.isTokenValid = true;
        return true;
      }
      this.isTokenValid = false;
      this.showPopover('fldToken');
      return false;
    },
    async existSecret() {
      try {
        const url = `${this.$store.getters.urlWebhook}/getSecret/${this.token}`;
        const config = {
          headers: {
            Authorization: `Bearer ${this.$store.getters.accessToken}`,
          },
        };
        const response = await axios.get(url, config);
        if (response.status === 200) {
          return response.data.exists;
        } else {
          return false;
        }
      } catch (e) {
        console.log(e);
        return false;
      }
    },
    async saveCredentials() {
      try {
        const url = `${this.$store.getters.urlWebhook}/createSecret`;
        const config = {
          headers: {
            Authorization: `Bearer ${this.$store.getters.accessToken}`,
          },
        };
        const body = {
          secret_name: `integration-id-${this.token}`,
          client_id: this.$store.getters.clientId,
          secret: this.secret,
        };
        const response = await axios.post(url, body, config);
        if (response.status === 200) {
          this.activeWoocomerce = true;
        }
        return response.data;
      } catch (e) {
        console.log(e);
      }
    },
    confirmDeleteSecret() {
      showConfirmation(
        this.$t('common.modals.confirmacionTitulo'),
        this.$t('integration.woocommerce.confirmation.delete'),
        async () => {
          await this.deleteSecret();
        },
      );
    },
    async deleteSecret() {
      try {
        this.deleteIntegrationBusy = true;
        const url = `${this.$store.getters.urlWebhook}/deleteSecret/${this.token}`;
        const config = {
          headers: {
            Authorization: `Bearer ${this.$store.getters.accessToken}`,
          },
        };
        const response = await axios.delete(url, config);
        if (response.status === 200) {
          this.activeWoocomerce = false;
        }
        this.deleteIntegrationBusy = false;
        return response.data;
      } catch (e) {
        this.deleteIntegrationBusy = false;
        console.log(e);
      }
    },
    transform() {
      const newUrl = this.addHttp(this.dominio);
      if (this.checkUrl(newUrl)) {
        this.badUrl = false;
        try {
          this.isWidgetCreated = false;
          const url = new URL(newUrl);
          this.urlIframe = this.buildUrl(url.hostname);
          this.generateCode();
          this.isWidgetCreated = true;
        } catch (e) {
          this.isWidgetCreated = false;
          console.log(e);
        }
      } else {
        this.isWidgetCreated = false;
        this.badUrl = true;
      }
    },
    checkUrl(url) {
      try {
        const regex = /^(https?:\/\/)?([\da-z.-]+)\.([a-z.]{2,6})([/\w .-]*)(\/#\/?[\w .-]*)*\/?$/;
        return regex.test(url);
      } catch (_) {
        return false;
      }
    },
    showPopover(id) {
      const wrongClass = 'form-control-warning';
      const multiselect = document.querySelector(`#${id}`);
      if (multiselect) {
        multiselect.classList.add(wrongClass);
        return;
      }
      if (document.getElementById(id)) {
        document.getElementById(id).classList.add(wrongClass);
      }
    },
    hidePopover(id) {
      const wrongClass = 'form-control-warning';
      const multiselect = document.querySelector(`#${id}`);
      if (multiselect) {
        multiselect.classList.remove(wrongClass);
        return;
      }
    },
    resetState() {
      this.isModalOpen = false;
      this.activeImage = null;
    },
    showModal(id) {
      this.$bvModal.show(id);
    },
    closeModal(id) {
      this.$bvModal.hide(id);
    },
    addHttp(url) {
      if (!/^https?:\/\//i.test(url)) {
        return 'https://' + url;
      }
      return url;
    },
    buildUrl(domain) {
      const hash = CryptoJS.SHA512(domain);

      // Convertir el hash a un WordArray
      const hashBytes = CryptoJS.enc.Hex.parse(hash.toString(CryptoJS.enc.Hex));

      // Reducir el hash a los primeros 32 bytes (64 caracteres hexadecimales)
      const reducedHashBytes = CryptoJS.lib.WordArray.create(hashBytes.words.slice(0, 8));

      // Convertir a cadena hexadecimal
      const token = reducedHashBytes.toString(CryptoJS.enc.Hex);
      const url = `${this.$store.getters.urlWidget}?accessKey=${token}`;
      return url;
    },
    generateCode() {
      this.iframeCode = `
        <iframe\n
          :src=${this.urlIframe}\n
          title="Widget de seguimiento\n"
          allowfullscreen\n
          loading="lazy"\n
          width="490"\n
          height="130"\n
        ></iframe>
      `;
    },
  },
  computed: {
    integrationsItems() {
      const integrations = [];
      this.integrations.forEach((integration) => {
        if (this.dataAccess.canNavRouteBoard && integration == 'API') {
          integrations.push(integration);
        } else if (this.dataAccess.canNavTracking) {
          integrations.push(integration);
        }
      });
      return integrations;
    },
    mappTitleField() {
      const common = {
        class: 'text-center',
        tdClass: 'small',
      };
      return [
        {
          key: 'shopifyColumn',
          label: this.$t('integration.shopify.instalationDescription.mapTable.shopifyTitle'),
          ...common,
        },
        {
          key: 'lastmileColumn',
          label: this.$t('integration.shopify.instalationDescription.mapTable.lastmileTitle'),
          ...common,
        },
      ];
    },
    mappTitleWCField() {
      const common = {
        class: 'text-center',
        tdClass: 'small',
      };
      return [
        {
          key: 'woocommerceColumn',
          label: this.$t('integration.woocommerce.mapTable.woocommerceTitle'),
          ...common,
        },
        {
          key: 'lastmileColumn',
          label: this.$t('integration.woocommerce.mapTable.lastMileTitle'),
          ...common,
        },
      ];
    },
  },
};
